import React, { useState, useEffect } from 'react'
import Gantt, {
  Tasks,
  Column,
  Editing,
  Toolbar,
  Item,
  ContextMenu,
} from 'devextreme-react/gantt'
import { locale, loadMessages } from 'devextreme/localization'
import {
  getTechnicalAssistanceImplementationActivities,
  getValidationImplementationActivity,
} from '../../../../../services/AsistenciaTecnica/get'
import { Popup } from 'devextreme-react/popup'
import { Grid, FormControl, TextField, Button } from '@material-ui/core'
import { Stack } from '@mui/material'
import swal from 'sweetalert'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { insertTechnicalAssistanceImplementationActivities } from '../../../../../services/AsistenciaTecnica/create'
import Moment from 'moment'
import { updateTechnicalAssistanceImplementationActivities } from '../../../../../services/AsistenciaTecnica/put'
import { deleteTechnicalAssistanceImplementationActivities } from '../../../../../services/AsistenciaTecnica/delete'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const Table26 = ({
  IdTechnicalAssistanceAnswer,
  StartExecutionPeriod,
  EndExecutionPeriod,
  formikSec,
}) => {
  loadMessages({
    es: {
      Yes: 'Sí',
      'dxCollectionWidget-noDataText': 'No hay registros a desplegar',
      'dxDataGrid-noDataText': 'No hay registros a desplegar',
      'No data': 'No hay registros a desplegar',
      'dxListEditDecorator-delete': 'Eliminar',
      'dxDataGrid-editingDeleteRow': 'Eliminar',
      'dxDataGrid-editingConfirmDeleteMessage':
        '¿Está seguro que desea eliminar este registro?',
      'dxScheduler-confirmRecurrenceDeleteMessage':
        '¿Quiere eliminar solo esta cita o toda la serie?',
      'dxScheduler-confirmRecurrenceDeleteSeries': 'Eliminar serie',
      'Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?':
        'Eliminar',
      'dxDataGrid-editingUndeleteRow': 'ff',
      'dxGantt-dialogTaskDeleteConfirmation':
        '¿Está seguro que desea eliminar este registro?',
      'dxGantt-dialogDependencyDeleteConfirmation': 'prueba2',
      'dxGantt-dialogResourcesDeleteConfirmation': 'prueba3',
      'dxGantt-dialogStartTitle': 'Inicio',
      'dxGantt-dialogEndTitle': 'Fin',
      'dxGantt-dialogTaskDetailsTitle': 'Editar',
      'dxGantt-contextMenuDeleteTask': 'Eliminar actividad',
      'dxGantt-zoomIn': 'Ampliar',
      'dxGantt-zoomOut': 'Alejar',
      'dxGantt-deleteSelectedTask': 'Elimimar actividad',
    },
  })
  locale('es')
  const [tasks, setTasks] = useState([])
  const [popupVisible, setPopupVisible] = useState(false)
  const [save, setSave] = useState(true)
  const [loading, setLoading] = useState(false)
  const [errorActividad, setErrorActividad] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    Activity: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
    StartDate: Yup.date().required('Este campo es obligatorio'),

    // .when(StartExecutionPeriod, {
    //   is: (StartExecutionPeriod) =>
    //     StartExecutionPeriod !== '' &&
    //     StartExecutionPeriod !== null &&
    //     StartExecutionPeriod !== undefined,
    //   then: Yup.date().min(
    //     StartExecutionPeriod,
    //     'No debe ser menor a la fecha de inicio',
    //   ),
    // }),

    // .min(StartExecutionPeriod, 'No debe ser menor a la fecha de inicio'),
    EndDate: Yup.date()
      .required('Este campo es obligatorio')
      // .min(StartExecutionPeriod, 'No debe ser menor a la fecha de inicio')
      // .max(EndExecutionPeriod, 'No debe ser mayor a la fecha de finalización')
      .when(
        'StartDate',
        (StartDate, schema) =>
          StartDate &&
          schema.min(
            StartDate,
            'La fecha de finalización no puede ser menor a la fecha de inicio.',
          ),
      ),
  })

  const formik = useFormik({
    validateOnChange: false,
    enableReinitialize: true,
    initialValues: {
      IdImplementationActivity: 0,
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Activity: '',
      StartDate: '',
      EndDate: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      save ? saveForm(values) : updateForm(values)
    },
  })

  const getTasksList = async () => {
    try {
      const response = await getTechnicalAssistanceImplementationActivities(
        IdTechnicalAssistanceAnswer,
      )
      var item = []
      for (var i = 0; i < response.Data.length; i++) {
        item[i] = {
          id: response.Data[i].IdImplementationActivity,
          parentId: 0,
          title: response.Data[i].Activity,
          start: new Date(response.Data[i].StartDate),
          end: new Date(response.Data[i].EndDate),
        }
      }
      setTasks(item)
      getValidation()
    } catch (error) {
      console.log(error)
    }
  }

  const getValidation = async () => {
    try {
      const response = await getValidationImplementationActivity(
        IdTechnicalAssistanceAnswer,
        StartExecutionPeriod,
        EndExecutionPeriod,
      )
      if (response.Success) {
        if (response.Data.Message) {
          formikSec('validateTable26', true)
        } else {
          formikSec('validateTable26', true)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (IdTechnicalAssistanceAnswer !== undefined) {
      getTasksList()
    }
  }, [IdTechnicalAssistanceAnswer])

  const aboutButtonOptions = {
    text: 'Agregar actividad',
    icon: 'add',
    stylingMode: 'text',
    elementAttr: {
      id: 'addicon',
      class: 'prueba',
    },
    onClick: (e) => {
      if (Moment(EndExecutionPeriod) > Moment(StartExecutionPeriod)) {
        changeDialog(e)
      } else {
        swal({
          title:
            'Favor validar que las fecha estén ingresadas y que la fecha fin  sea mayor a la fecha de inicio',
          icon: 'warning',
          button: 'Entendido',
        })
      }
    },
  }
  const changeDialog = async (e) => {
    e.cancel = true

    setPopupVisible(true)

    if (e.values) {
      setSave(false)
      formik.setValues({
        ...formik.values,
        IdImplementationActivity: Number(e.key),
        Activity: e.values.title,
        StartDate: Moment(e.values.start).format('YYYY-MM-DD'),
        EndDate: Moment(e.values.end).format('YYYY-MM-DD'),
      })
    }
  }

  const onHiding = async () => {
    setPopupVisible(false)
    formik.resetForm()
    setSave(true)
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const saveForm = async (values) => {
    setLoading(true)
    const response = await insertTechnicalAssistanceImplementationActivities(
      values,
    )
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getTasksList()
      onHiding()
      setLoading(false)
    }
  }

  const updateForm = async (values) => {
    const response = await updateTechnicalAssistanceImplementationActivities(
      values,
    )
    if (response.Success) {
      swal({
        title: '¡Datos actualizados exitosamente!',
        icon: 'success',
      })
      getTasksList()
      onHiding()
    }
  }

  const onDelete = async (e) => {
    handleDelete()
  }

  const handleDelete = async (e) => {
    try {
      const response = await deleteTechnicalAssistanceImplementationActivities(
        e.values.id,
      )

      if (response.Success) {
        swal({
          title: '¡Actividad eliminada exitosamente!',
          icon: 'success',
        })
        getTasksList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Gantt
        taskListWidth={500}
        scaleType="months"
        height={260}
        showResources={false}
        showDependencies={false}
        taskTitlePosition="none"
        onTaskUpdating={validateFormStatus}
        onTaskEditDialogShowing={changeDialog}
        onTaskDeleting={onDelete}
        onTaskDeleted={handleDelete}
      >
        <ContextMenu>
          <Item name="taskDetails" />
          <Item name="deleteTask" />
        </ContextMenu>
        <Tasks dataSource={tasks} />

        <Toolbar>
          <Item
            widget="dxButton"
            options={aboutButtonOptions}
            cssClass="prueba"
          />
          <Item name="deleteTask" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
          <Item>
            <div className="informer">
              <a
                data-tip="Para editar hacer doble clic sobre la actividad a modificar."
                data-for="infoCurrencyPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoCurrencyPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </div>
          </Item>
        </Toolbar>

        <Column dataField="title" caption="Actividad" width={300} />
        <Column dataField="start" caption="Fecha inicio" />
        <Column dataField="end" caption="Fecha fin" />

        {/* <Validation autoUpdateParentTasks /> */}
        <Editing enabled allowResourceAdding={false}></Editing>
      </Gantt>

      <Popup
        title="Nueva actividad"
        showTitle={true}
        width={700}
        height={300}
        visible={popupVisible}
        onHiding={onHiding}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              Actividad <span style={{ color: 'red' }}>*</span>
            </label>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  style={{ width: '100%' }}
                  variant="outlined"
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setErrorActividad(false)
                      formik.setFieldValue('Activity', e.target.value)
                    } else {
                      setErrorActividad(true)
                    }
                  }}
                  value={formik.values.Activity}
                  autoComplete={false}
                  inputProps={{
                    maxLength: 100,
                  }}
                />
                {formik.errors.Activity ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Activity}
                  </div>
                ) : null}
                {errorActividad ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
              </FormControl>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateStart"
                        // label=`Fecha Inicio ${<span style={{ color: 'red' }}>*</span>}`
                        label={
                          <>
                            Fecha Inicio <span style={{ color: 'red' }}>*</span>
                          </>
                        }
                        type="date"
                        name="ImplementationDateStart"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          formik.setFieldValue('StartDate', e.target.value)
                        }}
                        value={formik.values.StartDate}
                        inputProps={{
                          min: Moment(StartExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(EndExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                      />
                    </Stack>
                    {formik.errors.StartDate ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.StartDate}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateEnd"
                        name="ImplementationDateEnd"
                        label={
                          <>
                            Fecha fin <span style={{ color: 'red' }}>*</span>
                          </>
                        }
                        type="date"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          formik.setFieldValue('EndDate', e.target.value)
                        }}
                        value={formik.values.EndDate}
                        inputProps={{
                          min: Moment(formik.values.StartDate)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(EndExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                      />
                    </Stack>
                    {formik.errors.EndDate ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.EndDate}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="buttonsPYME">
            <Button className="cancelButton" onClick={onHiding}>
              Cancelar
            </Button>

            <Button
              className="confirmButton"
              onClick={validateFormStatus}
              disabled={loading}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Popup>
    </>
  )
}

export default React.memo(Table26)
